module.exports = __webpack_public_path__ + "files/abc679338c43e402a6d28eba3ddbd46f.png";